// import axios from "axios";
import { MEDTHOD } from "../constant/constant";
import {requestService as axios} from "./Request.service";

const API_URL = {
  GET_ALL_ITEMS: `/item/get_allitem.php`,
  Add_ITEM: `/item/add_item.php`,
  GET_ITEM: `/item/get_item.php`,
  GETSUP_ITEM: `/item/getsup_item.php`,
  Edit_ITEM: `/item/edit_item.php`,
  ERP_MATCH: `/item/erp-match.php`,
};

let contenttype = { "content-type": "application/x-www-form-urlencoded" };

const ItemService = {
  getAllItems: () => {
    return axios({
      method: MEDTHOD.GET,
      url: API_URL.GET_ALL_ITEMS,
      headers: contenttype,
      ignoreLoading : true,
    });
  },

  addItem: (reqData) => {
    return axios({
      method: MEDTHOD.POST,
      url: API_URL.Add_ITEM,
      headers: contenttype,
      data: reqData,
      ignoreLoading : true,
    });
  },

  getItem: (parm = {}) => {
    return axios({
      method: MEDTHOD.POST,
      url: API_URL.GET_ITEM,
      headers: contenttype,
      data: parm,
      ignoreLoading : true,
    });
  },
  
  getSupItem: (reqData) => {
    return axios({
      method: MEDTHOD.POST,      
      url: API_URL.GETSUP_ITEM,
      data: {
        idcode: reqData,
      },
      headers: contenttype,
      ignoreLoading : true,
    });
  },

  /* จับคู่กับสินค้าใน ERP */
  erpOptions: (q = "", stcode = "") =>
    axios({
      method: MEDTHOD.GET,
      url: `${API_URL.ERP_MATCH}?action=options&q=${encodeURIComponent(
        q
      )}&stcode=${encodeURIComponent(stcode || "")}`,
      ignoreLoading: true,
    }),

  erpUsage: (stcode) =>
    axios({
      method: MEDTHOD.GET,
      url: `${API_URL.ERP_MATCH}?action=usage&stcode=${encodeURIComponent(stcode)}`,
      ignoreLoading: true,
    }),

  erpMatch: (stcode, target_code) =>
    axios({
      method: MEDTHOD.POST,
      url: API_URL.ERP_MATCH,
      data: { stcode, target_code },
    }),

  editItem: (reqData) => {
    return axios({
      method: MEDTHOD.POST,
      url: API_URL.Edit_ITEM,
      headers: contenttype,
      data: reqData,
      ignoreLoading : true,
    });
  },
};

export default ItemService;
